import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, LogIn, Loader2 } from 'lucide-react';

var BACKEND = process.env.REACT_APP_BACKEND_URL;

function AdminLoginPage() {
  var [email, setEmail] = useState('');
  var [password, setPassword] = useState('');
  var [error, setError] = useState('');
  var [submitting, setSubmitting] = useState(false);
  var navigate = useNavigate();

  useEffect(function() {
    var t = localStorage.getItem('admin_token');
    if (t) navigate('/admin');
  }, [navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      var resp = await fetch(BACKEND + '/api/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, password: password })
      });
      var data = await resp.json();
      if (!resp.ok) throw new Error(data.detail || 'Login failed');
      localStorage.setItem('admin_token', data.token);
      localStorage.setItem('admin_email', data.email);
      navigate('/admin');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return React.createElement('div', { className: 'min-h-screen bg-black flex items-center justify-center px-6' },
    React.createElement('div', { className: 'max-w-md w-full' },
      React.createElement('div', { className: 'text-center mb-8' },
        React.createElement(Lock, { className: 'w-12 h-12 text-[#d4af37] mx-auto mb-3' }),
        React.createElement('h1', { className: 'text-3xl font-bold text-white' }, 'Admin Login'),
        React.createElement('p', { className: 'text-neutral-500 text-sm mt-2' }, 'JiMendez.com order management')
      ),
      React.createElement('form', { onSubmit: handleSubmit, className: 'bg-neutral-900 border border-white/10 rounded-2xl p-8 space-y-4' },
        React.createElement('div', null,
          React.createElement('label', { className: 'block text-neutral-400 text-sm mb-1' }, 'Email'),
          React.createElement('input', {
            type: 'email',
            required: true,
            'data-testid': 'admin-login-email',
            value: email,
            onChange: function(e) { setEmail(e.target.value); },
            className: 'w-full bg-neutral-950 border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#d4af37] focus:outline-none'
          })
        ),
        React.createElement('div', null,
          React.createElement('label', { className: 'block text-neutral-400 text-sm mb-1' }, 'Password'),
          React.createElement('input', {
            type: 'password',
            required: true,
            'data-testid': 'admin-login-password',
            value: password,
            onChange: function(e) { setPassword(e.target.value); },
            className: 'w-full bg-neutral-950 border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#d4af37] focus:outline-none'
          })
        ),
        error ? React.createElement('div', { 'data-testid': 'admin-login-error', className: 'bg-red-500/10 border border-red-500/30 rounded-lg p-3 text-red-300 text-sm' }, error) : null,
        React.createElement('button', {
          type: 'submit',
          disabled: submitting,
          'data-testid': 'admin-login-submit',
          className: 'w-full flex items-center justify-center gap-2 bg-[#d4af37] text-black font-semibold py-3 rounded-full hover:bg-white disabled:opacity-50'
        },
          submitting ? React.createElement(Loader2, { className: 'w-5 h-5 animate-spin' }) : React.createElement(LogIn, { className: 'w-5 h-5' }),
          submitting ? 'Signing in…' : 'Sign in'
        )
      )
    )
  );
}

export default AdminLoginPage;
